import type { Router } from 'next/router';

import {
    getBedsMax,
    getBedsMin,
    getDuration,
    getIsRetirementHome,
    getPriceFrequency,
    getPriceMax,
    getPriceMin,
    getPropertySubType,
    getPropertyType,
    getQ,
    getRadius,
    getTransportType
} from '.';

export const getFormValuesFromQuery = (query: Router['query']) => {
    return {
        beds_max: getBedsMax(query),
        beds_min: getBedsMin(query),
        duration: getDuration(query),
        is_retirement_home: getIsRetirementHome(query),
        price_frequency: getPriceFrequency(query),
        price_max: getPriceMax(query),
        price_min: getPriceMin(query),
        property_sub_type: getPropertySubType(query),
        property_type: getPropertyType(query),
        q: getQ(query),
        radius: getRadius(query),
        transport_type: getTransportType(query)
    };
};

export type FormValues = ReturnType<typeof getFormValuesFromQuery>;
